module.exports = __webpack_public_path__ + "static/img/mh.6a803acb.svg";